module.exports = __webpack_public_path__ + "img/18_78.19f43d3a.png";